<nz-table
	#engineRubricSkillTable
	[nzData]="engineRubricSkills"
	[nzLoading]="engineService.loading$ | async"
	[nzNoResult]="noData"
>
	<thead>
		<tr>
			<th>Engine Name</th>
			<th>Rubric Code</th>
			<th>Skill Code</th>
			<th>Created</th>
			<th>Updated</th>
			<th>Actions</th>
		</tr>
	</thead>
	<tbody>
		@for (prs of engineRubricSkills; track prs) {
			<tr [class.selected]="prs.uuid === engineService.selectedEngineRubricSkillBs$.value?.uuid">
				<td>{{ prs.engine_name }}</td>
				<td>{{ prs.rubric_code }}</td>
				<td>{{ prs.skill_code }}</td>
				<td>{{ prs.created | date: 'medium' }}</td>
				<td>{{ prs.updated | date: 'medium' }}</td>
				<td>
					@if (prs.uuid === engineService.selectedEngineRubricSkillBs$.value?.uuid) {
						<button nz-button (click)="selectEngineRubricSkill(undefined)">Clear</button>
					}
					@if (prs.uuid !== engineService.selectedEngineRubricSkillBs$.value?.uuid) {
						<span>&nbsp;</span>
						<button nz-button nzType="primary" (click)="selectEngineRubricSkill(prs)">Edit</button>
					}
					<span>&nbsp;</span>
					<button
						nz-button
						nzDanger
						nz-popconfirm
						nzPopconfirmTitle="Are you sure delete this EngineRubricSkill?"
						nzPopconfirmPlacement="bottom"
						(nzOnConfirm)="deleteEngineRubricSkill(prs.uuid)"
					>
						Delete
					</button>
				</td>
			</tr>
		}
	</tbody>
	<ng-template #noData>
		<nz-typography>No entries available</nz-typography>
	</ng-template>
</nz-table>
